'use strict';

export default class ListController {

  /*@ngInject*/
  constructor($http, $stateParams) {
    this.$http = $http;
    this.$stateParams = $stateParams;
  }

  $onInit() {
    this.getApp(this.$stateParams.id);
    this.getConfig(this.$stateParams.id);
  }

  getApp(id) {
    this.$http.get('/api/apks/' + id).then(response => {
      this.app = response.data;
      // this.getHistoryVersion(this.app.apkId);
    });
  }

  // getHistoryVersion(apkId) {
  //   this.$http.get('/api/apks/' + apkId + '/releases').then(response => {
  //     this.versions = response.data;
  //   });
  // }

  deleteApp(app) {
    if (confirm("确定？")) {
      this.$http.delete('api/apks/' + app._id).then(response => {
        this.getApp();
      });
    }
  }

  getConfig(id) {
    this.$http.get('/api/AppConfs', {params: {app: id}}).then(response => {
      this.config = response.data;
    })
  }

  deleteConf(id) {
    if (confirm("确定？")) {
      this.$http.delete('api/AppConfs/' + id).then(response => {
        this.getConfig(this.$stateParams.id);
      });
    }
  }

}



// WEBPACK FOOTER //
// ./client/app/appstore/show/show.controller.js